import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const RoomWorksiteAdminsPage = lazy(() =>
  import("./RoomWorksiteAdminsPage").then((module) => ({ default: module.RoomWorksiteAdminsPage })),
);

export function RoomWorksiteAdminsAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <RoomWorksiteAdminsPage />
    </Suspense>
  );
}
